import React, { useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CDP_PUBLIC_URL, REACT_APP_SITE_KEY } from '../../utils/Constants'
import '../../assets/css/App.css'
import '../../assets/css/DairitenConfirmPage.css'
import ReCAPTCHA from 'react-google-recaptcha'
import { callSaveAPI } from '../../api/CDPAPI'
import { useIntl } from 'react-intl'
import { PamphletPageNumber } from '../../utils/AppText'

const PamphletRequestConfirm = () => {
    document.title = '資料請求｜法人のお客様｜メットライフ生命'
    const location = useLocation()
    const data = location.state
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const intl = useIntl()
    const captchaRef = useRef(null)
    const recapture = async (e) => {
        const token = await captchaRef.current.executeAsync()
        await callSaveAPI('pamphlet-submit', { ...data, recaptchaToken: token })
        .then(res => {
            if (res.status === 200) {
                setLoading(false)
                captchaRef.current.reset()
                navigate(`${CDP_PUBLIC_URL}/pamphlet/complete`, { state: data })
            } else {
                if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                    navigate(`${CDP_PUBLIC_URL}/pamphlet`, { state: data })
                } else {
                    setLoading(false)
                }
            }
          }).catch(() => {
            if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                navigate(`${CDP_PUBLIC_URL}/pamphlet`, { state: data })
            } else {
                setLoading(false)
            }
          })
    }
    const handleSubmit = async (e) => {
        window.scrollTo(0, document.body.scrollHeight)
        e.preventDefault()
        recapture()
    }
    const handleBack = () => {
        navigate(`${CDP_PUBLIC_URL}/pamphlet`, { state: data })
    }
    return (
        <div className="dairiten-input-section-inputdetails">
            <div className="">
            </div>
            <div className="">
                <h2 id="h2" style={{ fontSize: 'large' }}>資料請求・相談サービスのお申し込み</h2>
                <p style={{ fontSize: 'larger' }}>資料ご送付先をご確認ください。</p>
                <p style={{ fontSize: 'larger' }}>この入力内容でよろしければ「送信」ボタンを押してください。<br></br>
                入力内容を変更する場合は「訂正」ボタンを押して入力画面に戻り、再入力してください。</p>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">ご希望のサービスを選択ください（複数選択可）</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">サービス（無料）</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data && data.service.join(', ')}</label>
                        </div>
                    </div>
                </div>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">ご希望の保険をお選びください（複数選択可）</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">商品名&nbsp;&nbsp;</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data && data.product.join(', ')}</label>
                        </div>
                    </div>
                </div>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">お客さまの情報について</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">団体名&nbsp;&nbsp;</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.groupName}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">団体名&nbsp;&nbsp;　フリガナ</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.groupNameKana}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">代表者名&nbsp;&nbsp;</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.representativeLastNameKanji}&nbsp;&nbsp;{data.representativeFirstNameKanji}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">代表者名&nbsp;&nbsp;　フリガナ</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.representativeLastNameKana}&nbsp;&nbsp;{data.representativeFirstNameKana}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご担当様部署名&nbsp;&nbsp;</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.deptName}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご担当者名&nbsp;&nbsp;</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.userLastNameKanji}&nbsp;&nbsp;{data.userFirstNameKanji}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご担当者名&nbsp;&nbsp;　フリガナ</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv row">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.userLastNameKana}&nbsp;&nbsp;{data.userFirstNameKana}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご住所</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">〒{data.zip1 + '-' + data.zip2}</label><br></br>
                            <label htmlFor="inputtext" className="col-form-label l1">{data.address1}</label><br></br>
                            <label htmlFor="inputtext" className="col-form-label l1">{data.address2}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">電話番号</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.phone}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">FAX番号</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.fax}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">ご希望の連絡方法</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.contact}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">E-mail</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.email}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">現在のご加入契約</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.contractStatus}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">団体総人数</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.groupSize}</label>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">（ご相談をご希望の場合）
                            <br></br>ご相談内容</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                            <label htmlFor="inputtext" className="col-form-label l1">{data.remarks}</label>
                        </div>
                    </div>
                </div>
            </div>
            {loading
                ? <div className='spinContainer'>
                      <div className='spin'></div>
                      <span><h2>{intl.formatMessage({ id: 'LoadingMsg' })}</h2></span>
                    </div>
                : <><div className="card-container-inputdetails row">
                        <p className="form-btn-01"><input type="submit" value="送信" name="submit" className="btn-submit" onClick={handleSubmit} /></p>
                    </div>
                    <div className="card-container-inputdetails row">
                        <p className="form-btn-01"><input type="submit" value="訂正" name="submit" className="btn-submit1" onClick={handleBack}/></p>
                    </div>
                    <p className="guard_mhp">{PamphletPageNumber}</p></>
                }
            <ReCAPTCHA sitekey={REACT_APP_SITE_KEY} size='invisible' ref={captchaRef} />
        </div>
    )
}

export default PamphletRequestConfirm
